module.exports = __webpack_public_path__ + "static/media/18ECA19.6a9120d1.jpg";